import { useQuery } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { APIInstance } from '@/utils/functions/instance'
import { GetAddressResponseType } from './type'

export function useGetAddress({
  data,
  disableToast,
  ...rest
}: IApiBaseTypes<{}>) {
  return useQuery({
    queryFn: async () => {
      const response = await APIInstance<GetAddressResponseType>({
        url: 'mrf/address/',
        params: data,
        method: 'get',
        data
      })
      return response
    },
    retry: 0,
    queryKey: ['address-item', data],
    select: (response) => response?.data,
    ...rest
  })
}
